var EHDI = (function(ehdi){
    ehdi.DBoneFactory =  (function(){
        var _public = Object.create(null);
        var enableClock = true;
        var armatures = [];
        var skelData = Object.create(null);

        var loop = function(dt){
            dragonBones.WorldClock.clock.advanceTime(dt * _public.dtMultiplier);
        }

        _public.dtMultiplier = 0.001;

        Object.defineProperty(_public, "enableClock", {
            set: function(val){
                enableClock = val;
                if(enableClock && !EHDI.GAME.updateManager.hasFrameListener(loop)){
                    EHDI.GAME.updateManager.addFrameListener(loop);
                }
                if(!enableClock && EHDI.GAME.updateManager.hasFrameListener(loop)){
                    EHDI.GAME.updateManager.removeFrameListener(loop);
                }
            },
            get: function(){
                return enableClock;
            }
        });

        _public.createArmature = function(name){
            var newArmature = _public.PixiFactory.buildArmature(name);
            dragonBones.WorldClock.clock.add(newArmature);
            armatures.push(newArmature);
            return newArmature;
        }

        _public.destroyArmature = function(armature){
            var index = armatures.indexOf(armature);
            if(index > -1){
                var arm = armatures.splice(index, 1)[0];
                dragonBones.WorldClock.clock.remove(arm);
                arm.dispose();
            }
        }

        _public.destroyAllArmature = function(){
            while(armatures.length > 0){
                var arm = armatures.pop();
                dragonBones.WorldClock.clock.remove(arm);
                arm.dispose();
            }
        }

        /**
        * @param (STRING) imgID texture file(png)
        * @param (STRING) dataID string file(json)
        * @param (STRING) SkelID string file(json)
        */
        _public.start = function(imgID, dataID, skelID){
            _public.PixiFactory = new dragonBones.PixiFactory();
            _public.addToFactory(imgID, dataID, skelID);
            _public.enableClock = true;
        }

        _public.addToFactory = function(imgID, dataID, skelID){
            var textureImg = EHDI.Assets.images[imgID].baseTexture.source;
            var textureData = EHDI.Assets.fetch(dataID);
            var skel = EHDI.Assets.fetch(skelID);
            
            _public.PixiFactory.addTextureAtlas(new dragonBones.TextureAtlas(textureImg, textureData));
            _public.PixiFactory.addDragonBonesData(dragonBones.DataParser.parseDragonBonesData(skel));
        }

        return _public;
        }());

    return ehdi;
}(EHDI || Object.create(null)));
